// It's preferable to keep your action types together.

// AWS
export const GET_PRICING_AWS = 'GET_PRICING_AWS';
export const GET_PRICING_AWS_SUCCESS = 'GET_PRICING_AWS_SUCCESS';
export const GET_PRICING_AWS_ERROR = 'GET_PRICING_AWS_ERROR';

// GCP
export const GET_PRICING_GCP = 'GET_PRICING_GCP';
export const GET_PRICING_GCP_SUCCESS = 'GET_PRICING_GCP_SUCCESS';
export const GET_PRICING_GCP_ERROR = 'GET_PRICING_GCP_ERROR';

// TYPES
export const SET_STORAGE_TYPES = 'SET_STORAGE_TYPES';

// VIEW
export const SWITCH_CHARTS_MODE = 'SWITCH_CHARTS_MODE';
export const SELECT_TAB = 'SELECT_TAB';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js